<template>
  <tbody>
    <tr v-if="header">
      <th colspan="3">{{ header }}</th>
    </tr>
    <template v-for="(value, item, index) in rows_after_link">
      <template v-if="!value.some(item => Array.isArray(item))">
        <tr :key="index">
          <td>{{ subTitle(item, value) }}</td>
          <td colspan="2" v-if='!isFacility()'>
            <span v-html="hrefize(value[0])"></span>
            <span class="description" v-if="value[2]">{{ value[2] }}</span><template v-for="(link, a) in (value.links || [])">
              <map-button v-if="Array.isArray(link[1])" hide-icon :text="link[0]" :coord="{ lon: link[1][1], lat: link[1][0] }" :key="'map_link_' + a" />
              <div v-else :key="'link_' + a">
                <a class="cx-link" target="_blank" :href="link[1]">{{ link[0] || link[1] }}</a>
              </div>
            </template>
          </td>
          <template v-else>
            <td style="text-align: center; width: 17%;">
              <img v-for="(img, v_index) in content(value)" :key="v_index"
                :src="`/static/accessibility/${img}.svg`"
                alt="" style="width: 20px; height: 20px; margin-right: 4px">
            </td>
            <td style="width: 50%;">
              <span>{{ value[0] }}</span>
              <span class="description" v-if="value[2]">{{ value[2] }}</span><template v-for="(link, a) in (value.links || [])">
                <map-button v-if="Array.isArray(link[1])" hide-icon :text="link[0]" :coord="{ lon: link[1][1], lat: link[1][0] }" :key="'map_link_' + a" />
                <div v-else :key="'link_' + a">
                  <a class="cx-link" target="_blank" :href="link[1]">{{ link[0] || link[1] }}</a>
                </div>
              </template>
            </td>
          </template>
        </tr>
      </template>

      <template v-else>
        <tr v-for="(subvalue, i_index) in value" :key="`${index}.${i_index}`">
          <td>{{ i_index === 0 ? subTitle(item, subvalue) : '' }}</td>
          <td>{{ subvalue[0] }}</td>
          <td>{{ subvalue[2] }}</td>
        </tr>
      </template>
    </template>
  </tbody>
</template>

<script>
import images from '@/constants/accessibilityImages.js';
import MapButton from '@/components/MapButton';

export default {
  name: 'accessibility-table',
  props: ['title', 'rows', 'header', 'settings'],
  components: {
    MapButton,
  },
  computed: {
    // https://3.basecamp.com/3633946/buckets/6317965/todos/8374787703
    rows_after_link() {
      const rows = {};
      Object.entries(this.rows).forEach(([item, value], index) => {
        if (Array.isArray(value) && value.length === 5 && value[4] && Array.isArray(value[4])) {
          const links = value[4];
          let val = value.slice(0, 4);
          if (val.slice(1).every(v => v === null)) {
            val = val.slice(0, 1);
          }
          val.links = links;
          rows[item] = val;
        } else {
          rows[item] = value;
        }
      });
      return rows;
    }
  },
  methods: {
    hrefize(value) {
      return `${value}`
        .replace(/(\+853)\s([\d]{4})\s([\d]{4})/g, '<a href="tel:$1$2$3">$1 $2 $3</a>')
        .replace(/((http|https):\/\/.*)$/g, '<a href="$1">$1</a>');
    },
    subTitle(item, value) {
      return value[1] ? `${item} - ${value[1]}` : item;
    },
    isFacility() {
      return this.title.toLowerCase() === this.settings.filter.section.toLowerCase();
    },
    content(value) {
      if (!this.isFacility()) {
        return value[0];
      }

      return Object.keys(value[3]).map(item => images[item][value[3][item]]);
    },
  },
};
</script>

<style lang="scss" scoped>
tbody {
  color: #343c3f;

  tr {
    border-top: 1px solid #b2bcbf;
  }
}
.description {
  display: block;
}
</style>